import { fleetClassNames } from "utils/fleetClasses";

export interface Category {
  name: string;
  /** How many cars carry the class. */
  count: number;
}

/**
 * The home page's type strip (1NOW-11175): one entry per fleet class, in first-seen order, with
 * how many cars are in it. Classes come from the
 * same place the Vehicles filter reads them (fleetClassNames), so a tile and its filter agree.
 */
export const fleetCategories = (cars: any[] | null | undefined): Category[] => {
  const byName = new Map<string, Category>();
  (cars ?? []).forEach((car) => {
    fleetClassNames(car).forEach((name) => {
      const entry = byName.get(name) ?? { name, count: 0 };
      entry.count += 1;
      byName.set(name, entry);
    });
  });
  return Array.from(byName.values());
};

export const carsLabel = (count: number) => `${count} ${count === 1 ? "car" : "cars"}`;
